export default "__VITE_ASSET__ZR2_Hasx__"